/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_UppercaseInputs */

const en_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Uppercase`)
};

const fr_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majuscules automatiques`)
};

const de_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Großschreibung`)
};

const it_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiuscolo automatico`)
};

const ru_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический ввод верхнего регистра`)
};

const es_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayúsculas automáticas`)
};

const zh_cn2_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动大写`)
};

const ja_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動大文字`)
};

const hi_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो अपरकेस`)
};

const pt_pt2_auto_uppercase = /** @type {(inputs: Auto_UppercaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiúsculas automáticas`)
};

/**
* | output |
* | --- |
* | "Auto Uppercase" |
*
* @param {Auto_UppercaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_uppercase = /** @type {((inputs?: Auto_UppercaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_UppercaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_uppercase(inputs)
	if (locale === "de") return de_auto_uppercase(inputs)
	if (locale === "it") return it_auto_uppercase(inputs)
	if (locale === "ru") return ru_auto_uppercase(inputs)
	if (locale === "es") return es_auto_uppercase(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_uppercase(inputs)
	if (locale === "ja") return ja_auto_uppercase(inputs)
	if (locale === "hi") return hi_auto_uppercase(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_uppercase(inputs)
	return en_auto_uppercase(inputs)
});